// The incident drawer renders on the Chakra v1 modal tier (1400), above the
// app banners (flex items at zIndex 'banner', 1200). The filter drawer sits on
// the same layer so both drawers overlay the banners identically, and its
// confirmation modals sit one tier up so they always paint above the drawer.
export const DRAWER_Z_INDEX = 1400
